import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'shared/services/redux/types';

const selectScheduleState = (state: RootState) => state.scheduleState;

export const scheduleSelectors = {
  getSchedule: createSelector(selectScheduleState, (state) => state.schedule),
  getScheduleIsLoading: createSelector(selectScheduleState, (state) => state.scheduleIsLoading),
  getFilters: createSelector(selectScheduleState, (state) => state.filters),
  getSelectedLesson: createSelector(selectScheduleState, (state) => state.selectedLesson),
  getViolations: createSelector(selectScheduleState, (state) => state.violations),
  getHighlightedErrors: createSelector(selectScheduleState, (state) => state.highlightedErrors),
  getHasErrors: createSelector(selectScheduleState, (state) => state.hasErrors),
  getColoredLessons: createSelector(selectScheduleState, (state) => state.coloredLessons),
  getConstraints: createSelector(selectScheduleState, (state) => state.constraints),
  getDifficultyDistribution: createSelector(
    selectScheduleState,
    (state) => state.difficultyDistribution,
  ),
  getCurrentBellSchedule: createSelector(selectScheduleState, (state) => state.bellSchedule),
  getReportStatus: createSelector(selectScheduleState, (state) => state.reportStatus),
  getEditMode: createSelector(selectScheduleState, (state) => state.editMode),
  getHideDifficultyDistributionConflicts: createSelector(
    selectScheduleState,
    (state) => state.hideDifficultyDistributionConflicts,
  ),
  getSuggestions: createSelector(selectScheduleState, (state) => state.suggestions),
};
